import Subscribe from "./Subscribe";

export default Subscribe;
